import { Record } from 'immutable'
import { getEntityMap } from 'data'

// Record
export const InvoiceRecord = Record(
  {
    id: '',
    amount: 0,
    number: '',
    pdfUrl: '',
    date: null,
    status: '',
  },
  'Invoice'
)

export function getAllInvoices(state) {
  return getEntityMap(state, 'Invoice')
    .toArray()
    .map(invoice => invoice.toJS())
    .sort(
      (invoiceA, invoiceB) => new Date(invoiceB.date) - new Date(invoiceA.date)
    )
}
